import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select_ok",
  "use": "icon-select_ok-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select_ok\">\n<g id=\"icon-select_ok_Group 179008\">\n<rect id=\"icon-select_ok_Rectangle 9035\" width=\"20\" height=\"20\" rx=\"10\" fill=\"url(#icon-select_ok_paint0_linear_1398_9754)\" />\n<path id=\"icon-select_ok_Vector 1153\" d=\"M6 10L8.64645 12.6464C8.84171 12.8417 9.15829 12.8417 9.35355 12.6464L15 7\" stroke=\"white\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\n</g>\n<defs>\n<linearGradient id=\"icon-select_ok_paint0_linear_1398_9754\" x1=\"4.09859e-08\" y1=\"10.9091\" x2=\"20.0005\" y2=\"10.9343\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FF524D\" />\n<stop offset=\"1\" stop-color=\"#FFAA5B\" />\n</linearGradient>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/select_ok.svg
// module id = d9u/
// module chunks = 102